(function () {
    'ngInject';

    angular.module('app.shared.services').factory('TokenAPIService', tokenAPIService);

    function tokenAPIService(HttpService) {
        function getPasswordToken(userName, password) {
            const data = $.param({
                username: userName,
                password: password,
                grant_type: 'password'
            });

            return HttpService.post('/token', data, 'application/x-www-form-urlencoded').then(function (data) {
                return data;
            });
        }

        /**
         * Get token by using the Shopify cookie if any
         */
        function getShopifyLoginToken() {
            const data = $.param({
                grant_type: 'shopify'
            });

            return HttpService.post('/token', data, 'application/x-www-form-urlencoded').then(function (data) {
                return data;
            });
        }

        return {
            getPasswordToken: getPasswordToken,
            getShopifyLoginToken: getShopifyLoginToken
        };
    }
})();
